<template>
  <div class="content-wrapper">
    <div class="container">
      <article>
        <section class="section white-panel pt20">
          <h2 class="fs16 bdb-solid-gradient1 pb8 mb8">洗車プリペイド利用規約</h2>

          <section>
            <h3 class="section-title-num bdb-solid-gray3 pb4 mb8 mt24">第1条 (総則)</h3>

            <ol class="ol-count">
              <li>本規約は、コスモ石油マーケティング株式会社（以下「当社」といいます。）が管理するアプリ「カーライフスクエア」（以下「本アプリ」といいます。）上で提供する洗車プリペイドサービス（以下「本サービス」といいます。）に関し、本サービスを利用される方（以下「利用者」という。）が遵守すべき事項および利用者と当社との関係を定めるものです。</li>
              <li>利用者は、本規約の他、本規約に付随して当社が定める規定、各種ガイドライン、マニュアル等（以下総称して「本規約等」といい、本アプリの利用規約を含みます。）を遵守するものとします。</li>
              <li>本サービスを利用して決済が行われる洗車サービスは、全てマイSS運営店（洗車サービスの提供者）が利用者に対して直接提供するものであって、当社が提供するものではありません。洗車サービスに関し、マイSS運営店と利用者との間で万が一トラブルが生じた場合には、利用者とマイSS運営店との間で解決していただくことになります。</li>
              <li>利用者が本規約等に違反した場合、当社は当該利用者に対し、サービス提供の停止、利用資格の取消、本アプリの利用資格の取消し、その他当社が必要と判断する一切の措置を講じることができるものとします。</li>
              <li>当社は、利用者が本サービスを利用した場合、当該利用者は本規約等に同意したものとみなします。</li>
              <li>利用者は、本サービス利用に先立ち、本アプリ上でマイSSを選択する必要があります。本サービスは利用前にご利用可能店舗として指定したマイSS運営店でのみ利用可能です(本アプリ上で選択できる全てのサービスステーションが本サービスの利用対象となるわけではなく、一部のサービスステーションでは本サービスを利用できません)。</li>
              <li>利用者は、本サービスの利用中に本アプリ上でマイSSを変更することができます。ただし、マイSSを変更した場合、変更前のマイSSの残ポイントを、変更後のマイSSに引き継ぐことはできないためご注意ください。</li>
            </ol>
          </section>

          <section>
            <h3 class="section-title-num bdb-solid-gray3 pb4 mb8 mt24">第2条 (本サービスの内容)</h3>
            <ol class="ol-count">
              <li>利用者は、マイSS運営店において洗車サービスを受ける際に、本サービス上の１ポイント１円換算にて、マイSS運営店への支払いに充てることができます。</li>
              <li>利用者は、本アプリ上で使用する洗車プリペイド（以下単に「ポイント」といいます。）を購入することができます。</li>
              <li>利用者は、マイSS運営店のサービスを受けるにあたって、ポイントとその他支払い手段とを併用することはできません。</li>
            </ol>
          </section>

          <section>
            <h3 class="section-title-num bdb-solid-gray3 pb4 mb8 mt24">第3条 (ポイントについて)</h3>
            <ol class="ol-count">
              <li>ポイントの発行主体は当社となります。</li>
              <li>ポイントの有効期間は購入日翌日を起算日とし180日となります。有効期間経過後は、残ポイント分は無効となり、残ポイントについて返金はされません。</li>
              <li>ポイントは原則１ポイント１円で、マイSS運営店での洗車サービスの利用時に使うことができます。</li>
              <li>当社は、利用者がポイントを購入する際に、購入金額に対して一定割合のポイントを加算することができます。また、当社は、本サービスの利用開始時等、任意のタイミングで任意のポイントを付与することができますが、一定の場合にポイントを付与することをお約束するものではありません。</li>
              <li>利用者は、本アプリ上でいつでも残ポイントおよび有効期限を確認することができます。</li>
              <li>ポイントは、クレジットカードでの購入に限られます。ポイントを購入するにあたっては、事前に、本アプリ上にてクレジットカード情報を登録いただく必要があります。</li>
              <li>ポイントは、購入後いかなる事由においても返金、換金することができず、再発行もできません。ただし、当社が社会情勢の変化、法令の改廃、その他当社の都合により、本サービスの取扱いを全面的に廃止する旨を決定した場合は、当社の定める手続に従って利用者は、ポイント残高の返金を求めることができます。</li>
            </ol>
          </section>

          <section>
            <h3 class="section-title-num bdb-solid-gray3 pb4 mb8 mt24">第4条 (禁止事項)</h3>
            <ol class="ol-count">
              <li>利用者は、本サービスの利用にあたっては、次の行為を行わないものとします。
              <ol class="ol-count">
                <li>自己のポイントを第三者に利用させる行為。</li>
                <li>本サービスにより知り得た情報を、私的利用以外の目的(営利目的等)で利用する行為、または本アプリを営業活動に利用する行為。</li>
                <li>第三者へのいやがらせ、誹謗、中傷、名誉を傷つける行為または猥褻的もしくは暴力的な行為。</li>
                <li>真実でない情報を発信する行為または当社へ情報登録を行う際に虚偽の届出をする行為。</li>
                <li>有害なコンピュータプログラムを送信する行為、本アプリを不正に改竄する行為、他人になりすます行為、当社・本サービス・第三者に危害や不利益を与える行為もしくは本サービスの運営を妨害する行為、またはそれらのおそれのある行為。</li>
                <li>当社および第三者の著作権、特許権、肖像権、商標権等の知的所有権、財産権、プライバシー権その他の権利や信用、名誉を侵害する行為またはそのおそれのある行為。</li>
                <li>ID等を不正に使用しまたは使用させる行為。</li>
                <li>当社が提供する情報を当社の承諾を得ることなく改変する行為。</li>
                <li>不正の目的をもって当社が提供する本サービスを利用する行為。</li>
                <li>手段を問わず、本サービスの運営を妨害する行為。</li>
                <li>選挙活動、またはこれに類する行為、その他の政治および宗教に関する行為。</li>
                <li>本規約のいずれかの条項に違反する行為。</li>
                <li>法令に違反する行為。</li>
                <li>公序良俗に反する行為。</li>
              </ol>
              </li>
              <li>利用者は、前項の規定その他本規約等に違反し、当社および第三者に損害を与えた場合、当該損害を賠償するものとします。</li>
            </ol>
          </section>

          <section>
            <h3 class="section-title-num bdb-solid-gray3 pb4 mb8 mt24">第5条  (利用者の責任等)</h3>
            <ol class="ol-count">
              <li>利用者は、自己の責任の下で、本サービスを利用するものとします。</li>
              <li>利用者とマイSS運営店との間でトラブル、紛争等が生じた場合は、利用者とマイSS運営店との間で直接解決するものとします。</li>
              <li>利用者が本規約等に違反し、その結果、利用者または第三者に損害が生じたとしても、当社は一切の責任を負いません。</li>
              <li>当社は、本サービスその他当社のウェブサイト、サーバ、ドメイン等から送られるデータ、プログラム、コンテンツ、電子メール等に、コンピュータウィルス等の有害なものが含まれないことを保証しません。利用者は、自己のパソコン等のデバイスにウィルス対策ソフトをインストールする等、必要な予防措置を講じるものとします。</li>
            </ol>
          </section>

          <section>
            <h3 class="section-title-num bdb-solid-gray3 pb4 mb8 mt24">第6条 (本サービス提供の中止・停止)</h3>
            <ol class="ol-count">
              <li>当社は、利用者が本規約等に違反した場合、もしくは次のいずれかに該当する場合、利用者に事前の通知または催告をすることなく、本サービスの提供を本サービスの提供を中止、または一時停止することができます。本サービスの提供が停止された場合であっても、購入済のポイントの有効期限の延長・変更は行わないものとします。また、本条に基づく中止・停止を理由とする利用者への返金等は行いません。
                <ol class="ol-count">
                  <li>利用者に対して、差押、仮差押、仮処分、強制執行または破産の申立てがなされた場合</li>
                  <li>その他、本サービスの利用者として不適格と当社が判断した場合</li>
                  <li>本サービスが不正使用されたとき、またはその疑いのあるとき</li>
                  <li>システムの障害その他の事由により本アプリ上で洗車プリペイドが使用不能となったとき</li>
                  <li>利用者による本サービスの利用が本規約に違反し、または違反するおそれのあるとき</li>
                  <li>その他やむを得ない事由が生じたとき</li>
                </ol>
              </li>
              <li>当社は、前項の本サービス提供の停止により、利用者に損害または不利益が生じたとしても、当社の責に帰すべき事由がある場合を除き、一切責任を負わないものとします。</li>
            </ol>
          </section>

          <section>
            <h3 class="section-title-num bdb-solid-gray3 pb4 mb8 mt24">第7条 (本サービスの変更、中断及び終了)</h3>
            <ol class="ol-count">
              <li>当社は、次のいずれかに該当する場合、利用者に対する事前の通知を行うことなく、本サービスの全部または一部の内容を変更、中断または終了できるものとします。
                <ol class="ol-count">
                  <li>本サービス提供に必要とする設備およびシステムの定期的または緊急の保守、点検もしくは更新を行う場合</li>
                  <li>システム障害対応またはその他技術上、運用上の理由による場合</li>
                  <li>天災、火災、停電等不測の事態のために本サービスの継続的な提供が困難となった場合</li>
                </ol>
              </li>
              <li>当社が、営業上、運用上もしくは技術上の理由により本サービスの中断もしくは終了が必要であると判断した場合、当社は、利用者が登録している本アプリまたは電子メールアドレス宛に発信する方法、または本サービスのウェブサイト内で表示する方法にて事前の通知を行うことにより、本サービスの提供を終了することができるものとします。</li>
              <li>当社は、本条により本サービスの全部または一部の提供内容を変更、中断または終了した場合、利用者または第三者が被った損害について、当社の責に帰すべき事由がある場合を除き、一切の責任を負わないものとします。</li>
            </ol>
          </section>
          <section>
            <h3 class="section-title-num bdb-solid-gray3 pb4 mb8 mt24">第8条 (個人情報)</h3>
            <p>本サービスの利用にあたって利用者が当社に対して個人情報を提供した場合、当社は、別途定める「カーライフスクエアアプリ・プライバシーポリシー」に従い取り扱うものとし、利用者はこれに同意するものとします。</p>
          </section>
          <section>
            <h3 class="section-title-num bdb-solid-gray3 pb4 mb8 mt24">第9条 (免責事項)</h3>
            <p>本サービスの利用に際して、利用者が被った損害について当社が責任を負う場合であっても、当社の故意または重過失がある場合を除き、当社の責任は直接かつ通常の損害に限られるものとします。</p>
          </section>
          <section>
            <h3 class="section-title-num bdb-solid-gray3 pb4 mb8 mt24">第10条  (損害賠償)</h3>
            <ol class="ol-count">
              <li>利用者が本規約等に違反した場合、または利用者の故意・過失により当社に損害や費用負担を生じさせた場合、利用者は当社に対して発生した損害または費用（弁護士費用を含む）を賠償する義務を負うものとします。</li>
              <li>利用者は、本サービス利用によって第三者に対して損害を与えた場合、自己の責任において解決し、当社に損害を与えないものとします。</li>
            </ol>
          </section>
          <section>
            <h3 class="section-title-num bdb-solid-gray3 pb4 mb8 mt24">第11条  (規約の改定)</h3>
            <ol class="ol-count">
              <li>当社は、次に掲げる場合、利用者から個別の同意を得ることなく当社の裁量で本利用規約を変更することができるものとします。
                <ol class="ol-count">
                  <li>利用規約の変更が、利用者の一般の利益に適合する場合</li>
                  <li>利用規約の変更が、契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性、その他の変更に係る事情に照らして合理的なものである場合</li>
                </ol>
              </li>
              <li>改定後の本規約等は当社が当社所定の本アプリ上または本サービスのウェブサイト上に効力発生日とともに事前に掲示します。ただし、前項1号の場合には、事前の掲示を行わないことができるものとします。</li>
            </ol>
          </section>
          <section>
            <h3 class="section-title-num bdb-solid-gray3 pb4 mb8 mt24">第12条  (管轄裁判所)</h3>
            <p>本規約等は日本国内法に基づき解釈されるものとし、本サービスに関連して訴訟の必要が生じた場合には、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。</p>
          </section>
          <p class="text-right">以上</p>

        </section>

      </article>
    </div>

  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  async mounted () {
  }
}
</script>
